import { Form } from '@anytag/shared-atoms';
import { PostReportFilter } from '@anytag/shared-organisms';
import { TikTokSpecialCampaignDetail } from '@anytag/graphql';
import { useTikTokCampaignReportFilter } from './hooks';
import { DownloadTikTokReportButton } from './DownloadTikTokReportButton';

export interface TikTokCampaignReportFilterProps {
  hasNoData?: boolean;
  tiktokSpecialCampaign: TikTokSpecialCampaignDetail;
}
export const TikTokCampaignReportFilter = ({ hasNoData, tiktokSpecialCampaign }: TikTokCampaignReportFilterProps) => {
  const { filter, setFilterForm } = useTikTokCampaignReportFilter();

  return (
    <PostReportFilter filter={filter} setFilter={setFilterForm}>
      <Form.Field className="flex-none">
        <DownloadTikTokReportButton disabled={hasNoData} tiktokSpecialCampaign={tiktokSpecialCampaign} />
      </Form.Field>
    </PostReportFilter>
  );
};
